(function HotelEngineStartBooking($, Adzuki) {
	'use strict';

	const emptyGuestFields = () => ({
		title      : '',
		first_name : '',
		last_name  : '',
		suffix     : '',
		email      : '',
		phone      : '',
		type       : 'adult',
		age        : '',
		room_number: 1,
	});

	const emptyBillingFields = () => ({
		title     : '',
		first_name: '',
		last_name : '',
		suffix    : '',
		email     : '',
		phone     : '',
		address1  : '',
		address2  : '',
		city      : '',
		state_iso : '',
		zip       : '',
	});

	const appConfig = {
		inject: {
			$inject_loggedIn: {
				default: () => Vue.ref(false)
			},
			setLoggedIn: {
				default: () => undefined
			}
		},
		data() {
			return {
				baseUri              : Adzuki.base_uri,
				siteUrl              : Adzuki.current_website || window.location.origin,
				giataId              : null,
				clientId             : null,
				rateKey              : null,
				hotel                : [],
				room                 : {},
				resumeHotel          : null,
				resumeRoom           : null,
				isLoading            : true,
				criteria             : {},
				coordinates          : {},
				paymentIntentId      : null,
				paymentDetailsChanged: false,
				billingSame          : true,
				primaryGuestForm     : emptyGuestFields(),
				billingForm          : emptyBillingFields(),
				paymentForm          : {
					name_on_card: null,
					number      : null,
					expiration  : null,
					type        : null,
					cvv         : null,
				},
				guestsByRoom        : {},
				additionalGuestForms: [],
				bookingForm         : {
					comments                 : '',
					loyalty_number           : '',
					airline_loyalty_number   : '',
					merge_into_reservation   : '',
					merge_into_reservation_id: '',
				},
				clientSelect            : [],
				reservationSelect       : [],
				statesList              : {},
				ages                    : Array.from({length: 18}, (_, i) => i),
				structuredRooms         : {},
				markupLowPercentage     : Adzuki.markupLowPercentage,
				markupHighPercentage    : Adzuki.markupHighPercentage,
				markupAdminFeePercentage: Adzuki.markupAdminFeePercentage,
				featureSpecialtyRates   : Adzuki.featureSpecialtyRates,
				numSpecialtyRates       : Adzuki.numSpecialtyRates,
				showRateBadges          : Adzuki.showRateBadges,
				showComparison          : Adzuki.showComparison,
				payLaterActive          : Adzuki.payLaterActive,
				paymentGateway          : Adzuki.paymentGateway,
				savingsBadgeModel       : Adzuki.savingsBadgeModel,
				savingsValueFormat      : Adzuki.savingsValueFormat,
				stripe                  : null,
				stripeKey               : '',
				stripeElements          : null,
				isProcessingPayment     : false,
				bookingAgreement        : false,
				finalCommission         : null,
				secureUrl               : null,
				billingInfo             : {},
				showModal               : false,
				modalType               : '',
				modalTitle              : '',
				modalProps              : {},
				threeDSecureHandler     : null,
				showAlert               : false,
				alertTitle              : null,
				alertMessage            : null,
				alertType               : null,
				pendingToast            : null,
				fieldErrors             : {}
			};
		},
		watch: {
			primaryGuestForm: {
				deep: true,
				handler() {
					if (this.shouldSyncBillingFromGuest) {
						this.syncBillingFromGuest();
					}
				},
			},
			billingSame(value) {
				if (value) {
					this.syncBillingFromGuest();
				}
			},
		},
		methods: {
			unwrapApiResponse(response) {
				if (!response || typeof response !== 'object') {
					return response;
				}

				if (response.response_data && typeof response.response_data === 'object') {
					return response.response_data;
				}

				return response;
			},
			clearSessionData() {
				sessionStorage.removeItem('formData');
				sessionStorage.removeItem('coordinates');
				sessionStorage.removeItem('searchCriteria');
				sessionStorage.removeItem('locationSearch');
				sessionStorage.removeItem('searchLocation');
				sessionStorage.removeItem('giataId');
				sessionStorage.removeItem('selectedHotel');
				sessionStorage.removeItem('selectedRoom');
				sessionStorage.removeItem('rate_select_string');

				this.$hotelDb.deleteDB();
			},
			getStateList() {
				try {
					// HeApi expects customer.state_iso as a 2-letter ISO code (alpha|max:2),
					// not a numeric state id from getByCountryId.
					fetch(`${this.baseUri}/States/getIsoByCountryId/183`)
						.then((response) => {
							if (!response.ok) {
								throw new Error('Failed to fetch states');
							}
							return response.json();
						})
						.then((states) => {
							this.statesList = states;
						})
						.catch((error) => {
							console.error("Error fetching states:", error);
							this.statesList = null;
						});
				} catch (error) {
					console.error("Unexpected error:", error);
					this.statesList = null;
				}
			},
			setFinalCommission(commission) {
				this.finalCommission = commission;
			},
			handleResInput(event) {
				const term = event.target.value;
				this.debounceApiCall = setTimeout(() => {
					if (term.length > 3) {
						this.fetchReservationSelect(term);
					}
				}, 300);
			},
			async fetchReservationSelect(term) {
				try {
					const response = await fetch(`${this.baseUri}/Reservations/autocompleteUpcoming/${encodeURIComponent(term)}`);
					const data = await response.json();
					this.reservationSelect = data;
				} catch (error) {
					console.error("Error fetching reservation select:", error);
				}
			},
			populateFromPrefill(customer) {
				if (!customer || typeof customer !== 'object') {
					return;
				}

				const guest = {
					title      : customer.title || '',
					first_name : customer.first_name || '',
					last_name  : customer.last_name || '',
					suffix     : customer.suffix || '',
					email      : customer.email || '',
					phone      : customer.phone || '',
					type       : 'adult',
					age        : '',
					room_number: 1,
				};

				this.primaryGuestForm = {...guest};

				this.billingForm = {
					...emptyBillingFields(),
					title     : guest.title,
					first_name: guest.first_name,
					last_name : guest.last_name,
					suffix    : guest.suffix,
					email     : guest.email,
					phone     : guest.phone,
					address1  : customer.address1 || '',
					address2  : customer.address2 || '',
					city      : customer.city || '',
					state_iso : customer.state_iso || '',
					zip       : customer.zip || '',
				};

				const nameOnCard = `${guest.first_name} ${guest.last_name}`.trim();

				if (nameOnCard) {
					this.paymentForm.name_on_card = nameOnCard;
				}
			},
			async fetchClientSelect() {
				const response = await fetch(`${this.baseUri}/Clients/getClientDetailsVue/` + this.clientId);
				const customer = await response.json();

				if (!customer || !customer.general) {
					return;
				}

				const primaryAddress = (customer.addresses && customer.addresses.length > 0)
					? (customer.addresses.find(addr => addr.primary === 'Yes') || customer.addresses[0])
					: {};

				this.populateFromPrefill({
					title     : customer.general.prefix,
					first_name: customer.general.first_name,
					last_name : customer.general.last_name,
					suffix    : customer.general.suffix,
					email     : customer.general.email,
					phone     : customer.general.mobile_phone,
					address1  : primaryAddress.address1,
					address2  : primaryAddress.address2,
					city      : primaryAddress.city,
					state_iso : primaryAddress.state_iso_code,
					zip       : primaryAddress.zip,
				});
			},
			syncBillingFromGuest() {
				const guest = this.primaryGuestForm;

				this.billingForm.title      = guest.title;
				this.billingForm.first_name = guest.first_name;
				this.billingForm.last_name  = guest.last_name;
				this.billingForm.suffix     = guest.suffix;
				this.billingForm.email      = guest.email;
				this.billingForm.phone      = guest.phone;
			},
			sanitizePhone(value) {
				if (value === null || value === undefined) {
					return '';
				}

				return String(value).replace(/\D/g, '');
			},
			isValidPhone(value) {
				if (!this.isFieldFilled(value)) {
					return false;
				}

				// Allow digits and common phone punctuation; reject letters
				return !(/[a-zA-Z]/).test(String(value));
			},
			buildCustomerPayload() {
				if (this.useStripeElements) {
					return {};
				}

				const customer = {...this.billingForm};

				if (this.shouldSyncBillingFromGuest) {
					customer.title      = this.primaryGuestForm.title;
					customer.first_name = this.primaryGuestForm.first_name;
					customer.last_name  = this.primaryGuestForm.last_name;
					customer.suffix     = this.primaryGuestForm.suffix;
					customer.email      = this.primaryGuestForm.email;
					customer.phone      = this.primaryGuestForm.phone;
				}

				customer.phone = this.sanitizePhone(customer.phone);

				return customer;
			},
			isFieldFilled(value) {
				return value !== null && value !== undefined && String(value).trim() !== '';
			},
			fieldError(key) {
				return this.fieldErrors[key] || '';
			},
			hasFieldError(key) {
				return Boolean(this.fieldErrors[key]);
			},
			clearFieldError(key) {
				if (!this.fieldErrors[key]) {
					return;
				}

				const next = {...this.fieldErrors};
				delete next[key];
				this.fieldErrors = next;
			},
			clearFieldErrors() {
				this.fieldErrors = {};
			},
			scrollToFirstFieldError() {
				this.$nextTick(() => {
					const firstErrorEl = document.querySelector('.hotel-booking-form .has-error');

					if (firstErrorEl) {
						firstErrorEl.scrollIntoView({
							behavior: 'smooth',
							block   : 'center',
						});
					}
				});
			},
			isGuestPartiallyFilled(guest) {
				if (!guest) {
					return false;
				}

				return Boolean(
					this.isFieldFilled(guest.first_name) ||
					this.isFieldFilled(guest.last_name) ||
					this.isFieldFilled(guest.email) ||
					this.isFieldFilled(guest.mobile_number) ||
					this.isFieldFilled(guest.phone) ||
					this.isFieldFilled(guest.title) ||
					this.isFieldFilled(guest.suffix) ||
					(guest.type === 'child' && this.isFieldFilled(guest.age))
				);
			},
			getRoomOccupants(room) {
				const occupants = [];
				const adults    = parseInt(room.num_adults || 0, 10);
				let childAges   = Array.isArray(room.child_ages) ? room.child_ages : [];

				if (!childAges.length) {
					const numChildren = parseInt(room.num_children || 0, 10);
					childAges = Array.from({length: numChildren}, () => '');
				}

				for (let i = 0; i < adults; i++) {
					occupants.push({
						type      : 'adult',
						guestIndex: i
					});
				}

				childAges.forEach((age, i) => {
					occupants.push({
						type      : 'child',
						guestIndex: adults + i,
						age
					});
				});

				return occupants;
			},
			createEmptyGuestSlot(roomIdx, guestType, age) {
				const slot = emptyGuestFields();
				slot.type        = guestType;
				slot.room_number = roomIdx + 1;

				if (guestType === 'child') {
					slot.age = age === undefined ? '' : age;
				}

				return slot;
			},
			getGuestSlotLabel(roomIdx, guestIndex) {
				const roomLabel = this.criteria.rooms?.length > 1 ? `Room ${roomIdx + 1}, ` : '';
				return `${roomLabel}Guest ${guestIndex + 1}`;
			},
			isGuestFormFieldRequired(field, guestIndex, guestType) {
				const HE = Adzuki.HotelEngine;

				if (field === 'title') {
					if (guestType === 'child') {
						return HE.isGuestFieldRequired(this.guestRules.childTitlePrefixes, guestIndex, guestType);
					}
					return HE.isGuestFieldRequired(this.guestRules.adultTitlePrefixes, guestIndex, guestType);
				}

				if (field === 'age') {
					return guestType === 'child' && this.guestRules.childDetails === true;
				}

				if (guestType === 'child') {
					return HE.isGuestFieldRequired(this.guestRules.childDetails, guestIndex, guestType);
				}

				return HE.isGuestFieldRequired(this.guestRules.adultDetails, guestIndex, guestType);
			},
			isBillingFieldRequired(field) {
				if (this.useStripeElements) {
					return false;
				}

				if (this.shouldSyncBillingFromGuest && ['title', 'first_name', 'last_name', 'email', 'phone'].includes(field)) {
					return false;
				}

				const billingFields = [
					'first_name',
					'last_name',
					'email',
					'phone',
					'address1',
					'city',
					'state_iso',
					'zip',
				];

				if (billingFields.includes(field)) {
					return true;
				}

				if (field === 'title') {
					return this.isGuestFormFieldRequired('title', 0, 'adult');
				}

				return false;
			},
			isPaymentFieldRequired(field) {
				if (this.useStripeElements) {
					return false;
				}

				return ['name_on_card', 'number', 'expiration', 'type', 'cvv'].includes(field);
			},
			normalizePaymentExpiration(value) {
				if (!this.isFieldFilled(value)) {
					return value;
				}

				const trimmed = String(value).trim();
				const ymMatch = trimmed.match(/^(\d{4})-(\d{2})$/);

				if (ymMatch) {
					return `${ymMatch[1]}-${ymMatch[2]}-01`;
				}

				const ymdMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);

				if (ymdMatch) {
					return `${ymdMatch[1]}-${ymdMatch[2]}-${ymdMatch[3]}`;
				}

				const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{2,4})$/);

				if (slashMatch) {
					const month = slashMatch[1].padStart(2, '0');
					const year  = slashMatch[2].length === 2 ? `20${slashMatch[2]}` : slashMatch[2];

					return `${year}-${month}-01`;
				}

				return trimmed;
			},
			isValidPaymentExpiration(value) {
				if (!this.isFieldFilled(value)) {
					return false;
				}

				const trimmed = String(value).trim();

				return ((/^\d{4}-\d{2}$/).test(trimmed)) ||
					((/^\d{4}-\d{2}-\d{2}$/).test(trimmed)) ||
					((/^\d{1,2}\/\d{2,4}$/).test(trimmed));
			},
			validateGuestFields(guest, guestIndex, guestType, keyPrefix) {
				const errors          = {};
				const requiredMessage = 'This field is required.';
				const requireField    = (field) => {
					if (!this.isGuestFormFieldRequired(field, guestIndex, guestType)) {
						return;
					}

					const value = guest ? guest[field] : null;

					if (!this.isFieldFilled(value)) {
						errors[`${keyPrefix}.${field}`] = requiredMessage;
					}
				};

				if (!guest) {
					requireField('title');
					requireField('first_name');
					requireField('last_name');

					if (guestIndex === 0 && guestType === 'adult') {
						errors[`${keyPrefix}.email`] = requiredMessage;
					}

					if (guestType === 'child') {
						requireField('age');
					}

					return errors;
				}

				requireField('title');
				requireField('first_name');
				requireField('last_name');

				if (guestIndex === 0 && guestType === 'adult' && !this.isFieldFilled(guest.email)) {
					errors[`${keyPrefix}.email`] = requiredMessage;
				}

				if (guestType === 'child') {
					requireField('age');
				}

				return errors;
			},
			validateBillingForm() {
				if (this.useStripeElements) {
					return {};
				}

				const errors               = {};
				const requiredMessage      = 'This field is required.';
				const invalidPhoneMessage  = 'Phone number cannot contain letters.';

				[
					'title',
					'first_name',
					'last_name',
					'email',
					'phone',
					'address1',
					'city',
					'state_iso',
					'zip',
				].forEach((field) => {
					if (!this.isBillingFieldRequired(field)) {
						return;
					}

					if (!this.isFieldFilled(this.billingForm[field])) {
						errors[`billing.${field}`] = requiredMessage;
					}
				});

				if (this.shouldSyncBillingFromGuest) {
					if (!this.isFieldFilled(this.primaryGuestForm.phone)) {
						errors['primary.phone'] = requiredMessage;
					} else if (!this.isValidPhone(this.primaryGuestForm.phone)) {
						errors['primary.phone'] = invalidPhoneMessage;
					}
				} else if (
					this.isFieldFilled(this.billingForm.phone)
					&& !this.isValidPhone(this.billingForm.phone)
				) {
					errors['billing.phone'] = invalidPhoneMessage;
				}

				if (
					this.isFieldFilled(this.primaryGuestForm.phone)
					&& !this.isValidPhone(this.primaryGuestForm.phone)
					&& !errors['primary.phone']
				) {
					errors['primary.phone'] = invalidPhoneMessage;
				}

				return errors;
			},
			validatePaymentForm() {
				if (this.useStripeElements) {
					return {};
				}

				const errors          = {};
				const requiredMessage = 'This field is required.';

				['name_on_card', 'number', 'expiration', 'type', 'cvv'].forEach((field) => {
					if (
						this.isPaymentFieldRequired(field)
						&& !this.isFieldFilled(this.paymentForm[field])
					) {
						errors[`payment.${field}`] = requiredMessage;
					}
				});

				if (
					this.isPaymentFieldRequired('expiration')
					&& this.isFieldFilled(this.paymentForm.expiration)
					&& !this.isValidPaymentExpiration(this.paymentForm.expiration)
				) {
					errors['payment.expiration'] = 'Please enter a valid expiration date.';
				}

				return errors;
			},
			validateGuestPax() {
				const errors = {};

				if (!this.bookingProvider) {
					errors._form = 'Unable to determine booking provider. Please restart your booking.';
					return errors;
				}

				if (!Array.isArray(this.criteria.rooms)) {
					return errors;
				}

				const requiresAllGuests = this.requiresAllGuestDetails;

				this.criteria.rooms.forEach((room, roomIdx) => {
					const occupants = this.getRoomOccupants(room);

					occupants.forEach((occupant) => {
						const {guestIndex, type} = occupant;
						const isPrimaryGuest     = roomIdx === 0 && guestIndex === 0;

						if (isPrimaryGuest) {
							Object.assign(
								errors,
								this.validateGuestFields(this.primaryGuestForm, guestIndex, type, 'primary')
							);
							return;
						}

						if (!requiresAllGuests) {
							return;
						}

						const slotIdx = guestIndex - (roomIdx === 0 ? 1 : 0);
						const guest   = this.guestsByRoom[roomIdx]?.[slotIdx];

						Object.assign(
							errors,
							this.validateGuestFields(guest, guestIndex, type, `room.${roomIdx}.${slotIdx}`)
						);
					});
				});

				if (!requiresAllGuests) {
					this.additionalGuestForms.forEach((guest, index) => {
						if (!this.isGuestPartiallyFilled(guest)) {
							return;
						}

						const keyPrefix = `additional.${index}`;
						const guestType = guest.type || 'adult';

						Object.assign(
							errors,
							this.validateGuestFields(guest, index + 1, guestType, keyPrefix)
						);

						if (!this.isFieldFilled(guest.type)) {
							errors[`${keyPrefix}.type`] = 'This field is required.';
						}
					});
				}

				return errors;
			},
			validateBookingForm() {
				const errors = {
					...this.validateGuestPax(),
					...this.validateBillingForm(),
				};

				if (!this.useStripeElements) {
					Object.assign(errors, this.validatePaymentForm());
				}

				if (!this.bookingAgreement) {
					errors.bookingAgreement = 'You must agree to the booking conditions.';
				}

				return errors;
			},
			async submitBooking() {
				if (this.isProcessingPayment) {
					return;
				}

				const errors = this.validateBookingForm();

				if (Object.keys(errors).length) {
					const formError = errors._form;

					this.fieldErrors = {...errors};
					delete this.fieldErrors._form;

					if (formError) {
						this.openAlert('error', 'Missing required information', formError);
					}

					this.scrollToFirstFieldError();
					return;
				}

				this.clearFieldErrors();

				this.isProcessingPayment = true;

				try {
					const formJsonData = {
						data: {
							customer : this.buildCustomerPayload(),
							payment  : {},
							comments : this.bookingForm.comments || "",
							pay_later: this.bookingForm.pay_later || false,
							pax      : []
						}
					};

					if (this.useStripeElements && this.stripeElements) {
						if (!this.paymentIntentId || this.paymentDetailsChanged) {
							await this.createPaymentIntent();

							if (!this.paymentIntentId) {
								this.isProcessingPayment = false;
								return;
							}
						}

						formJsonData.data.payment = {
							payment_intent: this.paymentIntentId || ""
						};
					} else {
						formJsonData.data.payment = {
							...this.paymentForm,
							expiration: this.normalizePaymentExpiration(this.paymentForm.expiration),
						};
					}

					if (this.finalCommission) {
						formJsonData.data.payment.additional_savings = this.finalCommission?.additional_savings || 0;
						formJsonData.data.payment.markup             = this.finalCommission?.markup || 0;
					}

					if (this.bookingForm.commission_percentage !== null && this.bookingForm.commission_percentage !== undefined) {
						formJsonData.data.commission_percentage = this.bookingForm.commission_percentage;
					}

					if (this.bookingForm.deposit_amount !== null && this.bookingForm.deposit_amount !== undefined) {
						formJsonData.data.deposit_amount = this.bookingForm.deposit_amount;
					}

					const additionalPax = this.getAllAdditionalGuests();
					const primaryPax    = this.formatGuestAsPax(this.primaryGuestForm, 1);

					if (additionalPax.length > 0) {
						formJsonData.data.pax = primaryPax
							? [primaryPax, ...additionalPax]
							: additionalPax;
					} else if (primaryPax) {
						formJsonData.data.pax = [primaryPax];
					}

					const formData = new FormData();
					formData.append('data', JSON.stringify(formJsonData.data));
					formData.append('hotel_id', this.giataId);
					formData.append('rate_select_string', this.rateKey);

					const submitBookingUrl = this.baseUri + '/HotelEngine/submitBooking';

					const response = await fetch(submitBookingUrl, {
						method: 'POST',
						body  : formData,
					});

					if (!response.ok) {
						throw new Error(`Error submitting booking: ${response.statusText}`);
					}

					const apiResponse = this.unwrapApiResponse(await response.json());

					if (apiResponse?.error) {
						if (this.isStaleRateError(apiResponse.error)) {
							this.redirectToHotelDetailsForStaleRate(apiResponse.error);
							return;
						}

						throw new Error(apiResponse.error);
					}

					if (apiResponse) {
						const threeDS   = apiResponse.three_d_secure;
						const secureUrl = typeof threeDS === 'string' ? threeDS : threeDS?.url;

						if (secureUrl) {
							this.secureUrl   = secureUrl;
							this.billingInfo = apiResponse.billing_data || this.billingInfo || {};

							if (apiResponse.payment_intent) {
								this.paymentIntentId = apiResponse.payment_intent;
							}

							if (apiResponse.room) {
								this.resumeRoom = apiResponse.room;
							}

							if (apiResponse.hotel) {
								this.resumeHotel = apiResponse.hotel;
							}

							this.open3dModal();
							return;
						}

						if (apiResponse.confirmation_number || apiResponse.reference_number) {
							if (Adzuki.app === 'Web') {
								window.location.href = this.baseUri + '/HotelSearch/bookingConfirmation/' + apiResponse.confirmation_number;
							} else {
								window.location.href = this.baseUri + '/HotelEngine/confirmation/' + apiResponse.confirmation_number;
							}
						}
					}
				} catch (error) {
					console.error('Error:', error);

					if (this.isStaleRateError(error?.message)) {
						this.redirectToHotelDetailsForStaleRate(error.message);
						return;
					}

					alert('Error submitting form: ' + error.message);
				} finally {
					if (!this.showModal) {
						this.isProcessingPayment = false;
					}
				}
			},
			selectReservation(reservation) {
				this.bookingForm.merge_into_reservation    = reservation.name;
				this.bookingForm.merge_into_reservation_id = reservation.id;
				this.reservationSelect                     = [];
			},
			initializeStripeElements() {
				if (!this.useStripeElements || this.stripe) {
					return;
				}

				if (window.Stripe) {
					this.$nextTick(() => this.createStripeElements());
				} else {
					const script = document.createElement('script');
					script.src = 'https://js.stripe.com/v3/';
					script.async = true;
					script.onload = () => {
						this.$nextTick(() => this.createStripeElements());
					};
					document.head.appendChild(script);
				}
			},
			createStripeElements() {
				const stripeTestKey  = 'pk_test_51R5FXjA8jMnToYv310Kg8tTGxrV9jkR86zh8d4SAy3GZvqTLlj1wNk1Xn6tHJkWNuK7A3rIQxAh1Ka65LkypWQzn00PfRLoHWS';
				const stripeStageKey = 'pk_test_51R5FXuPGMCMJ4WmVLPAmzKCxY0uYvyotlBBs00wkS3Px7u783DbAlcPBG65WGFMqQCSa0IVX20CuVF7mzfHyK8Dr00GRGiMctr';
				const stripeProdKey  = 'pk_live_51R5FXjA8jMnToYv3dJqwzsAvcBJudwuMVDBb3Za1agG5B0BPhAKUxUipz2BASYwiaGuZ1C9RtUN7zvhNE0STK3pZ00jacR4KJJ';

				if (Adzuki.dev === true) {
					this.stripeKey = stripeTestKey;
				} else if (Adzuki.stage === true) {
					this.stripeKey = stripeStageKey;
				} else {
					this.stripeKey = stripeProdKey;
				}

				// eslint-disable-next-line no-undef
				this.stripe = Stripe(this.stripeKey);

				this.stripeElements = this.stripe.elements({
					mode                 : 'payment',
					amount               : Math.round(this.roomPrices.totalPrice * 100),
					currency             : 'usd',
					paymentMethodCreation: 'manual',
					appearance           : {theme: 'flat'},
				});

				const paymentElement = this.stripeElements.create('payment');
				paymentElement.on('change', () => {
					this.paymentDetailsChanged = true;
				});

				const addressElement = this.stripeElements.create('address', {
					mode      : 'billing',
					fields    : {phone: 'always'},
					validation: {phone: {required: 'always'}},
				});

				const linkAuthElement = this.stripeElements.create('linkAuthentication');

				paymentElement.mount('#payment-element');
				addressElement.mount('#address-element');
				linkAuthElement.mount('#email-element');
			},
			async createPaymentIntent() {
				try {
					if (!this.useStripeElements || !this.stripe || !this.stripeElements) {
						return;
					}

					const {error: submitError} = await this.stripeElements.submit();

					if (submitError) {
						alert(`Stripe validation error: ${submitError.message}`);
						return;
					}

					const {error: pmError, paymentMethod} = await this.stripe.createPaymentMethod({
						elements: this.stripeElements
					});

					if (pmError) {
						alert(`Payment method error: ${pmError.message}`);
						return;
					}

					if (!paymentMethod) {
						alert('Failed to create payment method');
						return;
					}

					const paymentIntentForm = new FormData();
					const adjustments       = this.getPaymentAdjustments();

					paymentIntentForm.append('hotel_id', this.giataId);
					paymentIntentForm.append('rate_select_string', this.rateKey);
					paymentIntentForm.append('criteria', JSON.stringify(this.buildPaymentCriteria()));
					paymentIntentForm.append('markup', adjustments.markup);
					paymentIntentForm.append('additional_savings', adjustments.additional_savings);
					paymentIntentForm.append('amount', Math.round(this.roomPrices.totalPrice * 100));
					paymentIntentForm.append('payment_method_id', paymentMethod.id);

					const piResponse = await fetch(`${this.baseUri}/HotelEngine/createPaymentIntent`, {
						method: 'POST',
						body  : paymentIntentForm,
					});

					if (!piResponse.ok) {
						throw new Error(`Error creating payment intent: ${piResponse.statusText}`);
					}

					const piData = await piResponse.json();

					if (!piData.payment_intent) {
						throw new Error('No payment intent returned from server');
					}

					this.paymentIntentId       = piData.payment_intent;
					this.paymentDetailsChanged = false;
				} catch (error) {
					console.error('Error in createPaymentIntent:', error);
					alert(error.message || 'Error processing payment!');
					this.paymentIntentId = null;
				}
			},
			getFeeAmount(fee) {
				return Adzuki.HotelEngine.getFeeAmount(fee);
			},
			getPaymentAdjustments() {
				return {
					markup            : this.finalCommission?.markup || 0,
					additional_savings: this.finalCommission?.additional_savings || 0,
				};
			},
			buildPaymentCriteria() {
				const criteriaRooms = Array.isArray(this.criteria?.rooms) ? this.criteria.rooms : [];

				return {
					check_in : this.criteria?.check_in || this.criteria?.checkIn || '',
					check_out: this.criteria?.check_out || this.criteria?.checkOut || '',
					rooms    : criteriaRooms.map((room) => {
						let childAges = [];

						if (Array.isArray(room.child_ages)) {
							childAges = room.child_ages.map((age) => String(age));
						} else if (Array.isArray(room.childrenAges)) {
							childAges = room.childrenAges.map((age) => String(age));
						}

						return {
							num_adults  : String(room.num_adults ?? room.numAdults ?? 0),
							num_children: String(room.num_children ?? room.numChildren ?? 0),
							child_ages  : childAges,
						};
					}),
				};
			},
			addGuest() {
				this.additionalGuestForms.push({...emptyGuestFields()});
			},
			getAdditionalInfo() {
				const room = this.room?.room;

				if (!room) {
					return null;
				}

				switch (this.bookingProvider) {
					case 'hotelBeds': {
						const info = {};

						if (room.provider_data?.rate_comments) {
							info.rate_comments = room.provider_data.rate_comments;
						}

						if (room.type_and_category) {
							info.type_and_category = room.type_and_category;
						}

						return Object.keys(info).length ? info : null;
					}
					default:
						return null;
				}
			},
			openBookingConditionsModal(event) {
				if (event) {
					event.preventDefault();
				}

				this.modalTitle = 'Booking Conditions';
				this.modalType  = 'component';
				this.modalProps = {
					componentName : 'he-booking-conditions',
					componentProps: {
						cancellationPolicy: this.cancellationPolicies,
						property          : this.hotel?.property || null,
						pets              : this.hotel?.metadata?.pets || null,
						additionalInfo    : this.getAdditionalInfo(),
					},
				};
				this.showModal = true;
			},
			open3dModal() {
				if (!this.secureUrl) {
					alert('3D Secure verification URL is missing. Please try again.');
					return;
				}

				const iframeHtml = `<iframe id="three-d-secure-iframe" src="${this.secureUrl}" style="width:100%;height:500px;border:0;" allow="local-network-access *; payment https://js.stripe.com https://hooks.stripe.com; publickey-credentials-get https://js.stripe.com https://hooks.stripe.com; fullscreen *"></iframe>`;
				this.modalTitle = '3D Secure Authentication';
				this.modalType  = 'html';
				this.modalProps = {
					htmlContent: iframeHtml,
				};
				this.showModal = true;

				this.threeDSecureHandler = this.handle3dSecureResponse.bind(this);
				window.addEventListener('message', this.threeDSecureHandler, false);
			},
			handle3dSecureResponse(event) {
				if (!event.data || typeof event.data !== 'object') {
					return;
				}

				const {type, message, payment_intent: paymentIntentFromMessage} = event.data;

				if (!type || !['fraud_check_passed', 'fraud_check_fail', 'error'].includes(type)) {
					return;
				}

				window.removeEventListener('message', this.threeDSecureHandler, false);
				this.threeDSecureHandler = null;
				this.closeModal();

				if (paymentIntentFromMessage) {
					this.paymentIntentId = paymentIntentFromMessage;
				}

				if (type === 'fraud_check_passed') {
					this.completeBookingAfter3DS();
				} else if (type === 'fraud_check_fail') {
					this.isProcessingPayment = false;
					alert(message || 'Your 3D secure check failed. Please try again.');
				} else if (type === 'error') {
					this.isProcessingPayment = false;
					alert(message || 'An error occurred during 3D Secure verification.');
				}
			},
			async completeBookingAfter3DS() {
				if (!this.paymentIntentId) {
					this.isProcessingPayment = false;
					alert('Payment intent is missing after 3D Secure verification. Please try again.');
					return;
				}

				try {
					// The booking context (room/hotel/criteria/billing) is rehydrated
					// server-side from the payment intent, so only the payment intent
					// needs to be sent to resume the booking.
					const resumeBooking = new FormData();
					resumeBooking.append('payment_intent', this.paymentIntentId);

					const bookingResponse = await fetch(`${this.baseUri}/HotelEngine/resumeBooking`, {
						method: 'POST',
						body  : resumeBooking,
					});

					if (!bookingResponse.ok) {
						throw new Error(`Resume booking failed: ${bookingResponse.statusText}`);
					}

					const bookingData = this.unwrapApiResponse(await bookingResponse.json());

					if (bookingData.error) {
						throw new Error(bookingData.error);
					}

					if (Adzuki.app === 'Web') {
						window.location.href = this.baseUri + '/HotelSearch/bookingConfirmation/' + bookingData.confirmation_number;
					} else {
						window.location.href = this.baseUri + '/HotelEngine/confirmation/' + bookingData.confirmation_number;
					}
				} catch (error) {
					console.error('Error completing booking after 3D Secure:', error);
					alert('Error completing booking. Please try again.');
				} finally {
					this.isProcessingPayment = false;
				}
			},
			closeModal() {
				const wasUserDismissed = Boolean(this.threeDSecureHandler);

				if (this.threeDSecureHandler) {
					window.removeEventListener('message', this.threeDSecureHandler, false);
					this.threeDSecureHandler = null;
				}

				this.showModal   = false;
				this.modalType   = '';
				this.modalTitle  = '';
				this.modalProps  = {};
				this.secureUrl   = null;
				this.resumeHotel = null;
				this.resumeRoom  = null;

				if (wasUserDismissed) {
					this.isProcessingPayment = false;
				}
			},
			startNewSearch() {
				this.clearSessionData();

				if (Adzuki.app === 'Web') {
					window.location.href = Adzuki.current_website;
				} else {
					window.location.href = this.baseUri + '/HotelEngine';
				}
			},
			initializeGuestSlots() {
				if (!this.criteria.rooms || !Array.isArray(this.criteria.rooms)) {
					return;
				}

				this.criteria.rooms.forEach((room, roomIdx) => {
					if (!this.guestsByRoom[roomIdx]) {
						this.guestsByRoom[roomIdx] = [];
					}

					if (!this.requiresAllGuestDetails) {
						return;
					}

					const occupants = this.getRoomOccupants(room);
					const startIdx  = roomIdx === 0 ? 1 : 0;

					occupants.slice(startIdx).forEach((occupant, slotIdx) => {
						if (!this.guestsByRoom[roomIdx][slotIdx]) {
							this.guestsByRoom[roomIdx][slotIdx] = this.createEmptyGuestSlot(
								roomIdx,
								occupant.type,
								occupant.age
							);
						}
					});
				});
			},
			getRoomAdditionalGuests(roomIdx) {
				const room = this.criteria.rooms?.[roomIdx];

				if (!room) {
					return [];
				}

				const occupants = this.getRoomOccupants(room);
				const startIdx  = roomIdx === 0 ? 1 : 0;

				return occupants.slice(startIdx).map((occupant, slotIdx) => ({
					...occupant,
					slotIdx,
					label: this.getGuestSlotLabel(roomIdx, occupant.guestIndex),
				}));
			},
			handleCustomerSelected(client) {
				if (!client || !client._fullDetails) {
					return;
				}

				const clientDetails = client._fullDetails;

				if (clientDetails.general) {
					this.primaryGuestForm.first_name = clientDetails.general.first_name || '';
					this.primaryGuestForm.last_name  = clientDetails.general.last_name || '';
					this.primaryGuestForm.email      = clientDetails.general.email || '';
					this.primaryGuestForm.phone      = clientDetails.general.mobile_phone || '';
					this.primaryGuestForm.title      = clientDetails.general.prefix || '';
					this.primaryGuestForm.suffix     = clientDetails.general.suffix || '';
				}

				if (clientDetails.addresses && clientDetails.addresses.length > 0) {
					const primaryAddress = clientDetails.addresses.find(addr => addr.primary === "Yes") ||
						clientDetails.addresses[0];

					if (primaryAddress) {
						this.billingForm.address1  = primaryAddress.address1 || '';
						this.billingForm.address2  = primaryAddress.address2 || '';
						this.billingForm.city      = primaryAddress.city || '';
						this.billingForm.state_iso = primaryAddress.state_iso_code || '';
						this.billingForm.zip       = primaryAddress.zip || '';
					}
				}

				if (this.shouldSyncBillingFromGuest) {
					this.syncBillingFromGuest();
				}

				if (clientDetails.credit_cards && clientDetails.credit_cards.length > 0) {
					const primaryCard = clientDetails.credit_cards.find(card => card.primary === "Yes") ||
						clientDetails.credit_cards[0];

					if (primaryCard) {
						this.paymentForm = {
							name_on_card: primaryCard.name || '',
							expiration  : primaryCard.expiration || '',
							type        : primaryCard.credit_card_type_name || '',
							cvv         : null,
						};
					}
				}
			},
			formatGuestAsPax(guest, roomNumber) {
				if (!guest) {
					return null;
				}

				const firstName = (guest.first_name || '').trim();
				const lastName  = (guest.last_name || '').trim();

				if (!firstName && !lastName) {
					return null;
				}

				const pax = {
					first_name   : firstName,
					last_name    : lastName,
					title        : guest.title || '',
					email        : guest.email || '',
					mobile_number: guest.mobile_number || guest.phone || '',
					type         : guest.type || 'adult',
					room_number  : guest.room_number || roomNumber || 1,
				};

				if (guest.suffix) {
					pax.suffix = guest.suffix;
				}

				if (guest.age !== '' && guest.age !== undefined && guest.age !== null) {
					pax.age = guest.age;
				}

				if (guest.client_id) {
					pax.client_id = guest.client_id;
				}

				return pax;
			},
			getPaxFromAdditionalGuests() {
				const pax = [];

				this.additionalGuestForms.forEach((guest) => {
					const entry = this.formatGuestAsPax(guest, guest.room_number || 1);

					if (entry) {
						pax.push(entry);
					}
				});

				return pax;
			},
			getPaxFromGuestsByRoom() {
				const pax = [];

				Object.keys(this.guestsByRoom).forEach(roomIdx => {
					this.guestsByRoom[roomIdx].forEach((guest) => {
						const entry = this.formatGuestAsPax(guest, parseInt(roomIdx, 10) + 1);

						if (entry) {
							pax.push(entry);
						}
					});
				});

				return pax;
			},
			getAllAdditionalGuests() {
				return [
					...this.getPaxFromAdditionalGuests(),
					...this.getPaxFromGuestsByRoom(),
				];
			},
			openAlert(type, title, message) {
				this.showAlert    = true;
				this.alertTitle   = title;
				this.alertMessage = message;
				this.alertType    = type;
			},
			encodeUrlParam(data) {
				const json = JSON.stringify(data || {});

				return btoa(json)
					.replace(/\+/g, '-')
					.replace(/\//g, '_')
					.replace(/[=]+$/, '');
			},
			buildSearchCriteriaPayload() {
				const criteriaRooms = Array.isArray(this.criteria?.rooms) ? this.criteria.rooms : [];

				return {
					check_in : this.criteria?.check_in || this.criteria?.checkIn || '',
					check_out: this.criteria?.check_out || this.criteria?.checkOut || '',
					rooms    : criteriaRooms.map((room) => {
						let childAges = [];

						if (Array.isArray(room.child_ages)) {
							childAges = room.child_ages;
						} else if (Array.isArray(room.childrenAges)) {
							childAges = room.childrenAges;
						} else if (Array.isArray(room.ages)) {
							childAges = room.ages;
						}

						return {
							num_adults  : String(room.num_adults ?? room.numAdults ?? 1),
							num_children: String(room.num_children ?? room.numChildren ?? 0),
							child_ages  : childAges.map((age) => String(age)),
						};
					}),
				};
			},
			isStaleRateError(message) {
				const text = String(message || '').toLowerCase();

				return text.includes('rates not found') ||
					text.includes('no longer available') ||
					text.includes('rate is no longer');
			},
			redirectToHotelDetailsForStaleRate(message) {
				const criteria = this.buildSearchCriteriaPayload();
				const flashMessage = message || 'This rate is no longer available. Please choose another room or different dates.';

				sessionStorage.setItem('hotelSearchFlash', JSON.stringify({
					type   : 'error',
					title  : 'Rate no longer available',
					message: flashMessage,
				}));

				if (!this.giataId || !criteria.check_in || !criteria.check_out) {
					window.location.href = this.baseUri + '/HotelSearch/searchResults';
					return;
				}

				window.location.href = this.baseUri
					+ '/HotelSearch/hotelDetails/'
					+ this.giataId
					+ '/'
					+ this.encodeUrlParam(criteria);
			},
			openToast(status, message, options) {
				const toastComponent = this.$refs && this.$refs.toast;

				if (!toastComponent || typeof toastComponent.openToast !== 'function') {
					this.pendingToast = {
						status,
						message,
						options: options || {}
					};
					return;
				}

				toastComponent.openToast(status, message, options || {});
			}
		},
		computed: {
			isLoggedIn() {
				return Boolean(this.$inject_loggedIn && this.$inject_loggedIn.value);
			},
			useStripeElements() {
				return this.paymentGateway === 'stripe' && this.bookingProvider !== 'sabre';
			},
			shouldSyncBillingFromGuest() {
				return this.isLoggedIn || this.billingSame;
			},
			showBillingSameOption() {
				return !this.useStripeElements && !this.isLoggedIn;
			},
			bookingProvider() {
				const raw = this.room?.room?.provider;
				return Adzuki.HotelEngine.normalizeProviderKey(raw);
			},
			cancellationPolicies() {
				const room = this.room?.room;

				const empty = {
					format    : 'list',
					policies  : [],
					text      : '',
					hasContent: false,
				};

				if (!room) {
					return empty;
				}

				if (this.bookingProvider === 'sabre') {
					const sabrePolicy = room.provider_data?.hotel_descriptions?.cancellation_policy;

					if (typeof sabrePolicy === 'string' && sabrePolicy.trim()) {
						return {
							format    : 'text',
							policies  : [],
							text      : sabrePolicy,
							hasContent: true,
						};
					}

					return empty;
				}

				const policies = room.cancellation_policies || [];

				return {
					format    : 'list',
					policies,
					text      : '',
					hasContent: policies.length > 0,
				};
			},
			guestRules() {
				return Adzuki.HotelEngine.getProviderRules(this.bookingProvider);
			},
			requiresAllGuestDetails() {
				return Adzuki.HotelEngine.getRuleScope(this.guestRules.adultDetails) === 'allGuests';
			},
			showRequiredAdditionalGuests() {
				return this.requiresAllGuestDetails && this.totalOccupants.total > 1;
			},
			showOptionalAdditionalGuests() {
				return !this.requiresAllGuestDetails && this.totalOccupants.total > 1;
			},
			numNights() {
				const checkInDate  = new Date(this.criteria.check_in);
				const checkOutDate = new Date(this.criteria.check_out);

				if (checkOutDate <= checkInDate) {
					return 0;
				}

				return (checkOutDate - checkInDate) / (1000 * 60 * 60 * 24);
			},
			totalOccupants() {
				let totalAdults   = 0;
				let totalChildren = 0;

				if (Array.isArray(this.criteria.rooms)) {
					this.criteria.rooms.forEach((room) => {
						totalAdults   += Number(room.num_adults);
						totalChildren += Number(room.num_children);
					});
				}

				return {
					adults  : totalAdults,
					children: totalChildren,
					total   : totalAdults + totalChildren
				};
			},
			roomPrices() {
				if (!this.room?.room?.pricing) {
					return Adzuki.HotelEngine.emptyRatePrices();
				}

				const adjustments = this.getPaymentAdjustments();

				return Adzuki.HotelEngine.computeRatePrices(this.room.room, {
					numNights        : this.numNights || 1,
					numRooms         : this.criteria.rooms?.length || 1,
					markup           : adjustments.markup,
					additionalSavings: adjustments.additional_savings,
				});
			},
		},
		provide() {
			return {
				openAlert: this.openAlert,
				openToast: this.openToast,
			};
		},
		async mounted() {
			const container = document.getElementById('hotel-start-booking');
			const parseJsonSafe = (value) => {
				if (!value || typeof value !== 'string') {
					return null;
				}

				try {
					return JSON.parse(value);
				} catch (e) {
					return null;
				}
			};

			const datasetHotelId          = container?.dataset?.hotelId || '';
			const datasetSearchCriteria   = parseJsonSafe(container?.dataset?.searchCriteria ? atob(container.dataset.searchCriteria) : '');
			const datasetSelectedRoom     = parseJsonSafe(container?.dataset?.selectedRoom ? atob(container.dataset.selectedRoom) : '');
			const datasetRateSelectString = container?.dataset?.rateSelectString || '';
			const datasetClientId         = container?.dataset?.clientId || null;
			const datasetCustomerPrefill  = parseJsonSafe(container?.dataset?.customerPrefill ? atob(container.dataset.customerPrefill) : '');

			const storedHotel            = parseJsonSafe(sessionStorage.getItem('selectedHotel'));
			const storedSearchCriteria   = parseJsonSafe(sessionStorage.getItem('searchCriteria'));
			const storedRoom             = parseJsonSafe(sessionStorage.getItem('selectedRoom'));
			const storedRateSelectString = sessionStorage.getItem('rate_select_string');

			const resolvedSearchCriteria   = datasetSearchCriteria || storedSearchCriteria;
			const resolvedSelectedRoom     = datasetSelectedRoom || storedRoom;
			const resolvedRateSelectString = datasetRateSelectString || storedRateSelectString;

			const resolvedHotelId = datasetHotelId || sessionStorage.getItem('giataId') || '';
			const storedHotelMatches = storedHotel
				&& resolvedHotelId
				&& String(storedHotel.hotel_id) === String(resolvedHotelId);

			if (datasetHotelId) {
				this.giataId = datasetHotelId;
			}

			if (datasetClientId) {
				this.clientId = datasetClientId;
			}

			if (datasetCustomerPrefill) {
				this.populateFromPrefill(datasetCustomerPrefill);
			} else if (this.clientId) {
				await this.fetchClientSelect();
			}

			if (storedHotelMatches) {
				this.hotel = storedHotel;
			} else if (resolvedHotelId && resolvedSearchCriteria) {
				try {
					const formData = new FormData();
					formData.append('hotel_id', resolvedHotelId);
					formData.append('check_in', resolvedSearchCriteria.check_in);
					formData.append('check_out', resolvedSearchCriteria.check_out);
					formData.append('rooms', JSON.stringify(resolvedSearchCriteria.rooms));

					const response = await fetch(this.baseUri + '/HotelEngine/getHotelDetails', {
						method: 'POST',
						body  : formData,
					});

					if (response.ok) {
						const hotelData = await response.json();

						if (hotelData?.status === 'success' && hotelData.data) {
							this.hotel = hotelData.data;
						} else if (hotelData && (hotelData.hotel_id || hotelData.name)) {
							this.hotel = hotelData;
						}

						if (this.hotel) {
							sessionStorage.setItem('selectedHotel', JSON.stringify(this.hotel));
						}
					}
				} catch (error) {
					console.error('Error Loading Hotel:', error);
				}
			}

			if (resolvedSearchCriteria) {
				this.criteria = resolvedSearchCriteria;
			}

			if (resolvedSelectedRoom) {
				this.room = resolvedSelectedRoom;
			}

			if (resolvedRateSelectString) {
				this.rateKey = resolvedRateSelectString;
			}

			if (this.giataId && this.rateKey && this.criteria?.check_in) {
				try {
					const postCriteria = this.buildSearchCriteriaPayload();
					const formData     = new FormData();

					formData.append('rate_select_string', this.rateKey);
					formData.append('hotel_id', this.giataId);
					formData.append('criteria', JSON.stringify(postCriteria));

					const response = await fetch(this.baseUri + '/HotelEngine/selectRoom', {
						method: 'POST',
						body  : formData,
					});

					let data = null;

					try {
						data = await response.json();
					} catch (parseError) {
						data = null;
					}

					const message = data?.message || data?.error || '';

					if (!response.ok || data === false || data?.status === 'error' || data?.error) {
						if (this.isStaleRateError(message)) {
							this.redirectToHotelDetailsForStaleRate(
								message || 'This rate is no longer available. Please choose another room or different dates.'
							);
							return;
						}
					} else {
						const room = data?.status === 'success' && data.data ? data.data : data;

						if (room && typeof room === 'object') {
							this.room = room;
							sessionStorage.setItem('selectedRoom', JSON.stringify(room));
						}
					}
				} catch (error) {
					console.error('Error revalidating room rate:', error);
				}
			}

			this.getStateList();
			this.initializeGuestSlots();

			this.isLoading = false;

			this.$nextTick(() => {
				if (this.useStripeElements) {
					this.initializeStripeElements();
				}
			});
		},
	};

	$(document).ready(function documentReady() {
		const vueContainer = document.getElementById('hotel-start-booking');

		if (vueContainer) {
			const app         = Vue.createApp(appConfig);
			const loggedInRef = Vue.ref(vueContainer.dataset.loggedIn === '1' || vueContainer.dataset.loggedIn === 'true');

			app.provide('$inject_loggedIn', loggedInRef);
			app.provide('setLoggedIn', (val) => {
				loggedInRef.value = val;
			});

			app.component('adzuki-alert', Adzuki.VueComponents.AdzukiAlert);
			app.component('adzuki-toast', Adzuki.VueComponents.AdzukiToast);
			app.component('adzuki-modal', Adzuki.VueComponents.AdzukiModal);
			app.component('adzuki-loading', Adzuki.VueComponents.AdzukiLoading);
			app.component('adzuki-client-form', Adzuki.VueComponents.AdzukiClientForm);
			app.component('he-commission-adjuster', Adzuki.VueComponents.HotelEngineCommissionAdjuster);
			app.component('he-booking-conditions', Adzuki.VueComponents.HotelEngineBookingConditions);

			app.directive('formatCurrency', Adzuki.VueDirectives.FormatCurrency);
			app.directive('formatDate', Adzuki.VueDirectives.FormatDate);
			app.directive('tooltip', Adzuki.VueDirectives.Tooltip);

			app.mount('#hotel-start-booking');
		}
	});
}(jQuery, window.Adzuki || {}));
